<template>
    <span :class="wrapperClass">
        <input
            ref="input"
            :class="inputClass"
            :style="inputStyle"
            :id="id"
            :placeholder="isNativePlaceholder && placeholder"
            :maxlength="maxlength"
            :value="innerValue"
            v-bind="$attrs"
            v-on="listeners"
        >
        <label :class="labelClass" v-if="placeholder && !isNativePlaceholder" v-show="isShowPlaceholder"
               :for="id">{{placeholder}}</label>
        <span class="bx_count" v-if="showCount">
            <!-- [D] 0인 경우 : num 에 zero 클래스 추가 -->
            <span class="num" :class="{zero: isAddZeroClass}">{{valueLength}}</span>/{{maxlength}}
        </span>
    </span>
</template>

<script>
import inputs from '@/iamteacherpc/mixins/inputs.js';

export default {
    inheritAttrs: false,

    props: {
        id: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        isNativePlaceholder: {
            default: false,
        },
        value: {},
        showCount: {
            type: Boolean,
            default: false,
        },
        maxlength: {
            type: Number,
        },
        wrapperClass: {
            default: 'bx_input',
        },
        inputClass: {
            default: 'input_txt',
        },
        inputStyle: {},
        labelClass: {
            default: 'input_lbl',
        },
    },

        mixins: [inputs],

        data() {
            return {}
        },
    }
</script>
